import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Dashboard from '@mui/icons-material/Dashboard';
import MoneyIcon from '@mui/icons-material/Savings';
import Code from '@mui/icons-material/Code';
import StreamIcon from '@mui/icons-material/Stream';
import GridBotIcon from '@mui/icons-material/Grid3x3';
import SubscriptionsIcon from '@mui/icons-material/Refresh';


import Logs from '@mui/icons-material/Summarize';
import AdminIcon from '@mui/icons-material/Security';
import Settings from '@mui/icons-material/Settings';
import SignalDashboard from '@mui/icons-material/DashboardCustomize';

import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../interface/ApplicationState';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { toggleDrawer } from '../../redux/actions/userActions';
import { DrawerHeader } from './DrawerHeader';
import { CustomDrawer } from './CustomDrawer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { alpha, useTheme } from '@mui/material/styles';



export const NavigationDrawer = () =>
{
  const theme = useTheme()
  const isAdmin = useSelector((state: ApplicationState) => state.userStore.user.isAdmin)
  const isDrawerOpen = useSelector((state: ApplicationState) => state.userStore.isDrawerOpen)
  const dispatch = useDispatch()

  return(
    <CustomDrawer
      open={isDrawerOpen}
      variant="permanent" >

    <DrawerHeader>
      <IconButton
        onClick={() => dispatch(toggleDrawer(!isDrawerOpen))}
        sx={{
          width: 38,
          height: 38,
          borderRadius: '12px',
          border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.08 : 0.6)}`,
          backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.04 : 0.7),
        }}
      >
        {<ChevronLeftIcon />}
      </IconButton>
    </DrawerHeader>
    
     <Box sx={{ px: isDrawerOpen ? 1.5 : 1, pt: 1.5, pb: 1 }}>
      {isDrawerOpen && (
        <Box
          sx={{
            mb: 2,
            p: 1.5,
            borderRadius: '14px',
            border: `1px solid ${alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.08 : 0.6)}`,
            backgroundColor: alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.04 : 0.52),
          }}
        >
          <Typography variant="overline" sx={{ letterSpacing: 1.4, color: alpha(theme.palette.text.primary, 0.62) }}>
            Workspace
          </Typography>
          <Typography sx={{ fontSize: 18, lineHeight: 1.2, mt: 0.5 }}>
            AlgoTrader
          </Typography>
          <Chip
            size="small"
            label="Live navigation"
            sx={{
              mt: 1.25,
              borderRadius: '999px',
              backgroundColor: alpha(theme.palette.info.main, theme.palette.mode === 'dark' ? 0.14 : 0.12),
            }}
          />
        </Box>
      )}

     <List sx={{ px: 0 }}>
       {/* Dashboard */}
       <NavLink to="/dashboard" style={styles.link}>
        {({ isActive }) => (
          <ListItem disablePadding sx={styles.listItem}>
          <ListItemButton sx={styles.button(theme, isActive, isDrawerOpen)}>
            <ListItemIcon sx={styles.icon(theme, isActive, isDrawerOpen)}>
              <Dashboard />
            </ListItemIcon>
            <ListItemText primary="Dashboard" sx={styles.text(isActive, isDrawerOpen)} />
          </ListItemButton>
        </ListItem>) }
      </NavLink>

      <NavLink to="/gridbot" style={styles.link}>
        {({ isActive }) => (
          <ListItem disablePadding sx={styles.listItem}>
          <ListItemButton sx={styles.button(theme, isActive, isDrawerOpen)}>
            <ListItemIcon sx={styles.icon(theme, isActive, isDrawerOpen)}>
              <GridBotIcon />
            </ListItemIcon>
            <ListItemText primary="Grid Bot" secondary="Beta" sx={styles.text(isActive, isDrawerOpen)} />
          </ListItemButton>
        </ListItem>
        )}
      </NavLink>

      {/* Backtesting Overview */}
      <NavLink to="/backtesting" style={styles.link}>
        {({ isActive }) => (
          <ListItem disablePadding sx={styles.listItem}>
          <ListItemButton sx={styles.button(theme, isActive, isDrawerOpen)}>
            <ListItemIcon sx={styles.icon(theme, isActive, isDrawerOpen)}>
              <Code />
            </ListItemIcon>
            <ListItemText primary="Backtesting" sx={styles.text(isActive, isDrawerOpen)} />
          </ListItemButton>
        </ListItem>) }
      </NavLink>


      {/* Trends */}
      <NavLink to="/signals" style={styles.link}>
        {({ isActive }) => (
          <ListItem disablePadding sx={styles.listItem}>
          <ListItemButton sx={styles.button(theme, isActive, isDrawerOpen)}>
            <ListItemIcon sx={styles.icon(theme, isActive, isDrawerOpen)}>
              <StreamIcon />
            </ListItemIcon>
            <ListItemText primary="Signals" sx={styles.text(isActive, isDrawerOpen)} />
          </ListItemButton>
        </ListItem>) }
      </NavLink>

        {/* Logs */}
        <NavLink to="/logs" style={styles.link}>
        {({ isActive }) => (
          <ListItem disablePadding sx={styles.listItem}>
          <ListItemButton sx={styles.button(theme, isActive, isDrawerOpen)}>
            <ListItemIcon sx={styles.icon(theme, isActive, isDrawerOpen)}>
              <Logs />
            </ListItemIcon>
            <ListItemText primary="Logs" sx={styles.text(isActive, isDrawerOpen)} />
          </ListItemButton>
        </ListItem>) }
      </NavLink>

      { isAdmin && <NavLink to="/admin" style={styles.link}>
        {({ isActive }) => (
          <ListItem disablePadding sx={styles.listItem}>
          <ListItemButton sx={styles.button(theme, isActive, isDrawerOpen)}>
            <ListItemIcon sx={styles.icon(theme, isActive, isDrawerOpen)}>
              <AdminIcon />
            </ListItemIcon>
            <ListItemText primary="User Admin" sx={styles.text(isActive, isDrawerOpen)} />
          </ListItemButton>
        </ListItem>
        )}
      </NavLink> }

     

       { isAdmin && <NavLink to="/subscriptions" style={styles.link}>
        {({ isActive }) => (
          <ListItem disablePadding sx={styles.listItem}>
          <ListItemButton sx={styles.button(theme, isActive, isDrawerOpen)}>
            <ListItemIcon sx={styles.icon(theme, isActive, isDrawerOpen)}>
              <SubscriptionsIcon />
            </ListItemIcon>
            <ListItemText primary="Subscriptions" sx={styles.text(isActive, isDrawerOpen)} />
          </ListItemButton>
        </ListItem>
        )}
      </NavLink> }
    
      <NavLink to="/settings" style={styles.link}>
        {({ isActive }) => (
          <ListItem disablePadding sx={styles.listItem}>
          <ListItemButton sx={styles.button(theme, isActive, isDrawerOpen)}>
            <ListItemIcon sx={styles.icon(theme, isActive, isDrawerOpen)}>
              <Settings />
            </ListItemIcon>
            <ListItemText primary="Settings" sx={styles.text(isActive, isDrawerOpen)} />
          </ListItemButton>
        </ListItem>
        )}
      </NavLink>

    

  </List>
  </Box>
  </CustomDrawer>
   
  )
}

const styles = {
  link: {
    textDecoration: "none",
  },
  listItem: {
    mb: 0.5,
  },
  button: (theme: any, isActive: boolean, isDrawerOpen: boolean) => ({
    minHeight: 48,
    px: isDrawerOpen ? 1.25 : 1,
    justifyContent: isDrawerOpen ? 'initial' : 'center',
    borderRadius: '12px',
    color: isActive ? theme.palette.common.white : alpha(theme.palette.text.primary, 0.7),
    background: isActive
      ? `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.info.main})`
      : 'transparent',
    '&:hover': {
      backgroundColor: isActive
        ? undefined
        : alpha(theme.palette.common.white, theme.palette.mode === 'dark' ? 0.05 : 0.65),
    },
  }),
  icon: (theme: any, isActive: boolean, isDrawerOpen: boolean) => ({
    minWidth: 0,
    mr: isDrawerOpen ? 1.5 : 'auto',
    justifyContent: 'center',
    color: isActive ? theme.palette.common.white : alpha(theme.palette.text.primary, 0.72),
  }),
  text: (isActive: boolean, isDrawerOpen: boolean) => ({
    opacity: isDrawerOpen ? 1 : 0,
    '& .MuiTypography-root': {
      fontSize: 14,
      fontWeight: isActive ? 700 : 500,
    },
    '& .MuiListItemText-secondary': {
      opacity: 0.8,
    },
  }),
}
